<template>
    <div
        :style="styles"
        class="o-otg-start-tiles"
    >
        <router-link
            v-for="category in categories"
            :key="category.id"
            :to="{
                name: category.redirect.name,
                params: {
                    categoryId: category.redirect.categoryId,
                    path: category.redirect.path
                }
            }"
            tag="button"
            class="otg-start-tiles-button"
        >
            <span class="otg-start-tiles-container">
                <img 
                    :src="category.icon" 
                    :alt="category.altText"
                    class="otg-start-tiles-icon"
                >
                <span class="otg-start-tiles-title">
                    {{ $t(category.title) }}
                </span>
            </span>
        </router-link>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'OOtgStartTiles',
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        params() {
            return this.getMapConfigProp('components.OOtgStartTiles.params') || {};
        },
        categories() {
            return this.params.categories || [];
        },
        styles() {
            return this.getMapConfigProp('components.OOtgStartTiles.styles') || {};
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />